<template>
    
<!--
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ]
  }
  ```
-->
<div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <router-link to="/" class="block mx-auto w-48">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
    </router-link>
    <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
      Sign up as a tutor
    </h2>
    <p class="mt-2 text-center text-sm text-gray-600 max-w">
      Already a member?
      <router-link to="/sign-in" class="font-medium text-blue-600 hover:text-blue-500">
        Sign in
      </router-link>
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <form @submit.prevent="onSubmit" class="space-y-6">
        <div>
          <label for="name" class="block text-sm font-medium text-gray-700">
            Name
          </label>
          <div class="mt-1">
            <input v-model="name" id="name" name="name" autocomplete="name" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <p v-if="$v.name.$dirty && !$v.name.required" class="mt-2 text-sm text-red-600">Please enter your name.</p>
        </div>
        
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Email address
          </label>
          <div class="mt-1">
            <input v-model="email" id="email" name="email" type="email" autocomplete="email" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <p v-if="$v.email.$dirty && !$v.email.required" class="mt-2 text-sm text-red-600">Please enter your email address.</p>
          <p v-if="$v.email.$dirty && !$v.email.email" class="mt-2 text-sm text-red-600">Please enter a valid email address.</p>
        </div>

        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">
            Password
          </label>
          <div class="mt-1">
            <input v-model="password" id="password" name="password" type="password" autocomplete="current-password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <p v-if="$v.password.$dirty && !$v.password.required" class="mt-2 text-sm text-red-600">Please enter a password.</p>
          <p v-if="$v.password.$dirty && !$v.password.minLength" class="mt-2 text-sm text-red-600">Password must be at least 6 characters.</p>
        </div>

        <div>
          <div class="flex items-center">
            <input v-model="agreeToTerms" id="agreeToTerms" name="agreeToTerms" type="checkbox" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
            <label for="agreeToTerms" class="ml-2 block text-sm text-gray-900">
              I agree to the <button type="button" @click="showTerms = true" class="text-blue-600 underline">terms & conditions</button>
            </label>
          </div>
          <p v-if="$v.agreeToTerms.$dirty && !$v.agreeToTerms.checked" class="mt-2 text-sm text-red-600">You must agree to the terms & conditions.</p>
        </div>

        <!-- <div class="flex items-center justify-between">
          <div class="flex items-center">
            <input id="remember_me" name="remember_me" type="checkbox" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
            <label for="remember_me" class="ml-2 block text-sm text-gray-900">
              Remember me
            </label>
          </div>

          <div class="text-sm">
            <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500">
              Forgot your password?
            </a>
          </div>
        </div> -->

        <div>
            <tti-button type="submit" :loading="submitting" :disabled="submitting" class="w-full justify-center">
                Sign up
            </tti-button>
        </div>

        <p v-if="duplicateUser" class="text-red-600 text-sm">A user with this email address already exists.</p>
      </form>

      <!-- <div class="mt-6">
        <div class="relative">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-300"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-2 bg-white text-gray-500">
              Or continue with
            </span>
          </div>
        </div>

        <div class="mt-6 grid grid-cols-3 gap-3">
          <div>
            <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Sign in with Facebook</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path fill-rule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clip-rule="evenodd" />
              </svg>
            </a>
          </div>

          <div>
            <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Sign in with Twitter</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
          </div>

          <div>
            <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Sign in with GitHub</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clip-rule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  
  <tti-terms-modal :show="showTerms" @agree="agreeToTerms = true; showTerms = false;" @close="showTerms = false">
    <tti-terms-body @version="termsVersion = $event"></tti-terms-body>
  </tti-terms-modal>

</div>


</template>
<script>

import { required, email, minLength } from 'vuelidate/lib/validators'

import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6Le7yWEbAAAAAPvs9RJ9432eA5rQuFea9EHWsBI3' })

import AuthService from '../services/AuthServices'
const authService = new AuthService()

export default {
    components: {
        'tti-button': () => import('./TailwindButton'),
        'tti-terms-modal': () => import('./TermsModal'),
        'tti-terms-body': () => import('./TermsAndConditionsBody')
    },
    data() {
        return {
            email: null,
            password: null,
            name: null,
            agreeToTerms: false,
            termsVersion: null,
            showTerms: false,
            submitting: false,
            duplicateUser: false
        }
    },
    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      },
      name: {
        required
      },
      agreeToTerms: {
        checked: value => { return value }
      }
    },
    methods: {
        async onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.submitting = true;

            let recaptchaToken = await this.initRecaptcha()

            var response;
            try {
              response = await authService.signUp(this.email, this.password, this.name, this.termsVersion, recaptchaToken)  
            } 
            catch {
              this.duplicateUser = true;
            }
            finally {
              this.submitting = false;
            }

            localStorage.setItem('token', response.data.token);
            this.$router.push('/my-account/');
        },
        async initRecaptcha() {
          // (optional) Wait until recaptcha has been loaded.
          await this.$recaptchaLoaded()

          // Execute reCAPTCHA with action "login".
          const token = await this.$recaptcha('login')

          // Do stuff with the received token.
          return token
        }
    }
}
</script>